var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktop = function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.342 18.72H2.66a1.623 1.623 0 0 1-1.62-1.621V15.6h23.92v1.502a1.62 1.62 0 0 1-1.618 1.618ZM10.4 22.88h5.2v-3.12h-5.2v3.12ZM2.66 1.04h20.682a1.62 1.62 0 0 1 1.618 1.618V14.56H1.04V2.661c0-.894.728-1.621 1.62-1.621ZM23.342 0H2.66A2.664 2.664 0 0 0 0 2.661V17.1a2.665 2.665 0 0 0 2.66 2.661h6.7v3.12H7.28v1.04h11.44v-1.04h-2.08v-3.12h6.702A2.661 2.661 0 0 0 26 17.102V2.658A2.661 2.661 0 0 0 23.342 0Z"
  })));
};
export default SvgDesktop;